import * as React from 'react';

import {FlashBanner} from 'shells/flash-banner/flash-banner';

import {analyticsClient} from '../../analytics-client';

import styles from './ie-deprecation.module.css';

export function IeDeprecation() {
    const [shouldShow, setShouldShow] = React.useState<boolean>(false);

    React.useEffect(() => {
        if (Nut.isUsingIe()) {
            analyticsClient.track(analyticsClient.EVENTS.TRACK_IE_DEPRECATION_NOTICE_SHOWN);
            setTimeout(() => {
                setShouldShow(true);
            }, 2000);
        }
    }, []);

    if (shouldShow) {
        return (
            <div className={styles['ie-deprecation']}>
                <FlashBanner
                    type='default'
                    animate={true}
                    hasBorder={true}
                    onHidden={() => {
                        setShouldShow(false);
                    }}
                >
                    <span>
                        The browser you are using (Internet Explorer) has been replaced by Microsoft
                        Edge, and will no longer be supported by Nutshell after March 1, 2020.{' '}
                        <a
                            href='https://support.microsoft.com/en-us/help/17171/microsoft-edge-get-to-know'
                            target='_blank'
                            rel='noreferrer noopener'
                        >
                            Get to know Microsoft Edge.
                        </a>
                    </span>
                </FlashBanner>
            </div>
        );
    }

    return null;
}
